/** sessionStorage key for new-session route/gate selection */
export const NEW_SESSION_ROUTE_KEY = 'newSession_routeSelection';

/**
 * sessionStorage key for the in-progress new-session form values. Written
 * before navigating away to the route picker (which unmounts SessionForm and
 * would otherwise wipe rider/description/etc.), consumed once on remount.
 */
export const NEW_SESSION_FORM_KEY = 'newSession_formValues';

/** Parse-guarded sessionStorage read; a corrupt entry is deleted and ignored. */
export function readStash<T>(key: string): T | null {
  const stored = sessionStorage.getItem(key);
  if (!stored) return null;
  try {
    return JSON.parse(stored) as T;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
}

export function writeStash(key: string, value: unknown): void {
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function clearStash(key: string): void {
  sessionStorage.removeItem(key);
}
